class DosageCalculator extends HTMLElement {
  connectedCallback() {
    this.currency = this.dataset.currency || 'EUR';

    this.weightGroup = this.querySelector('[data-pill-group="weight"]');
    this.packageGroup = this.querySelector('[data-pill-group="package"]');
    this.dosagePerDayEl = this.querySelector('[data-dosage-per-day]');
    this.daysLeftEl = this.querySelector('[data-days-left]');
    this.costPerDayEl = this.querySelector('[data-cost-per-day]');

    if (!this.weightGroup || !this.packageGroup) return;

    this.setupPillGroup(this.weightGroup);
    this.setupPillGroup(this.packageGroup);

    this.selectDefaultVariant();
    this.watchVariantChanges();
    this.calculate();
  }

  setupPillGroup(group) {
    group.querySelectorAll('.dosage-calc__pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        group.querySelectorAll('.dosage-calc__pill').forEach((p) => p.setAttribute('aria-pressed', 'false'));
        pill.setAttribute('aria-pressed', 'true');

        if (group === this.packageGroup) {
          this.syncVariantSelection(pill.dataset.variantId);
        }
        this.calculate();
      });
    });

    if (!group.querySelector('[aria-pressed="true"]')) {
      const first = group.querySelector('.dosage-calc__pill');
      if (first) first.setAttribute('aria-pressed', 'true');
    }
  }

  getVariantInput() {
    return document.querySelector('form[action*="/cart/add"] input[name="id"]');
  }

  selectDefaultVariant() {
    const input = this.getVariantInput();
    const currentId = input ? input.value : null;
    const pills = Array.from(this.packageGroup.querySelectorAll('.dosage-calc__pill'));
    const match = currentId && pills.find((p) => p.dataset.variantId === currentId);

    pills.forEach((p) => p.setAttribute('aria-pressed', 'false'));
    (match || pills[0])?.setAttribute('aria-pressed', 'true');
  }

  syncVariantSelection(variantId) {
    const input = this.getVariantInput();
    if (input && variantId && input.value !== variantId) {
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  watchVariantChanges() {
    const input = this.getVariantInput();
    if (!input) return;
    this.currentVariantId = input.value;

    const syncFromProduct = () => {
      if (input.value === this.currentVariantId) return;
      this.currentVariantId = input.value;
      const pills = Array.from(this.packageGroup.querySelectorAll('.dosage-calc__pill'));
      const match = pills.find((p) => p.dataset.variantId === input.value);
      if (match) {
        pills.forEach((p) => p.setAttribute('aria-pressed', 'false'));
        match.setAttribute('aria-pressed', 'true');
        this.calculate();
      }
    };

    input.addEventListener('change', syncFromProduct);
    new MutationObserver(syncFromProduct).observe(input, { attributes: true, attributeFilter: ['value'] });
  }

  calculate() {
    const weightPill = this.weightGroup.querySelector('[aria-pressed="true"]');
    const packagePill = this.packageGroup.querySelector('[aria-pressed="true"]');
    const dosage = weightPill ? parseFloat(weightPill.dataset.dosage) : 0;
    const content = packagePill ? parseFloat(packagePill.dataset.content) : 0;
    const price = packagePill ? parseFloat(packagePill.dataset.price) : 0;

    if (!dosage || !content) {
      this.dosagePerDayEl.textContent = '–';
      this.daysLeftEl.textContent = '–';
      this.costPerDayEl.textContent = '–';
      return;
    }

    const days = Math.floor(content / dosage);
    const costPerDay = days > 0 ? (price / 100) / days : 0;

    this.dosagePerDayEl.textContent = `${dosage} g`;
    this.daysLeftEl.textContent = days > 0 ? `${days} dagen` : '–';
    this.costPerDayEl.textContent = days > 0
      ? new Intl.NumberFormat('nl-NL', { style: 'currency', currency: this.currency }).format(costPerDay)
      : '–';
  }
}

if (!customElements.get('dosage-calculator')) {
  customElements.define('dosage-calculator', DosageCalculator);
}
